import React, { useEffect } from 'react';
import { Prompt, PromptProps, useLocation } from 'react-router-dom';

import { APP_ROUTES } from '../../constants/routes';

export const ExitPrompt = (props: PromptProps) => {
  const location = useLocation();

  // Default confirmation message
  const defaultMessage = 'Are you sure you want to leave? Unsaved changes will be lost.';

  // Handle beforeunload event (browser/tab closing)
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (!props.when) {
        return;
      }

      event.preventDefault();
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [props.when]);

  // Check if path belongs to wizard
  const isWizardPath = (path) => {
    if (!path) return false;

    const isFleetWizard = Object.values(APP_ROUTES.fleetWizard).some((wizardPath) => {
      return path.startsWith(wizardPath);
    });

    const isAuthorityWizard = Object.values(APP_ROUTES.authorityWizard).some((wizardPath) => {
      return path.startsWith(wizardPath);
    });

    return isFleetWizard || isAuthorityWizard;
  };

  // Simple handler that only blocks navigation when leaving the wizard
  const handleMessage = (nextLocation) => {
    const currentPath = location.pathname;
    const nextPath = nextLocation.pathname || '';

    const isCurrentInWizard = isWizardPath(currentPath);
    const isNextInWizard = isWizardPath(nextPath);

    // If both are within the wizard, allow navigation without confirmation
    if (isCurrentInWizard && isNextInWizard) {
      return true;
    }

    // If leaving wizard, show confirmation using standard React Router behavior
    // This will use the message from props or our default
    if (isCurrentInWizard && !isNextInWizard) {
      return props.message || defaultMessage;
    }

    // For all other cases where props.when is true, also show confirmation
    if (props.when) {
      return props.message || defaultMessage;
    }

    // For all other cases, allow navigation
    return true;
  };

  return <Prompt when={props.when} message={handleMessage} />;
};
